module.exports = "<mat-dialog-content>\r\n    <div class=\"body\">\r\n        <i class=\"zmdi zmdi-alert-octagon\"></i>\r\n        <p [innerHTML]=\"denyMessage\"></p>\r\n    </div>\r\n</mat-dialog-content>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/deny.component.html
// module id = ../../../../../client/app/shared/common/deny.component.html
// module chunks = main